import React, { useEffect, useState } from "react";
import style from "./Filter.module.css";
import search from "../../../Assets/search.svg";
import filterIcon from "../../../Assets/filter.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  applicationActions,
  filterActions,
  postActions,
  recruiterActions,
} from "../../../redux/actions";
import * as api from "../../../services/api";
import { Box, Wrap, useLatestRef } from "@chakra-ui/react";
import Chip from "pages/Student/NewUpload/Chip";
import { TagsInput } from "Components/TagInput/TagInput";
import { useLocation } from "react-router-dom";

const PortFolioFilter = ({ setSearchTags }) => {
  const dispatch = useDispatch();
  const [projectTypeState, setProjectTypeState] = useState("");
  const [tools, setTools] = useState("");
  const text = useSelector((state) => state.filters.text);
  const tool = useSelector((state) => state.filters.tools);
  const category = useSelector((state) => state.filters.category);
  const level = useSelector((state) => state.filters.level);
  const location = useSelector((state) => state.filters.location);
  const salary = useSelector((state) => state.filters.salary);

  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(filterActions.setText(""));
    dispatch(filterActions.setCategory(""));
    dispatch(filterActions.setLevel(""));
    dispatch(filterActions.setLocation(""));
    dispatch(filterActions.setSalary(""));
    dispatch(filterActions.setTools(""));
  }, [pathname]);

  useEffect(() => {
    dispatch(applicationActions.getApplicationsForUser());
  }, []);
  useEffect(() => {
    dispatch(postActions.getPostsForStudent());
  }, []);

  const searchChangeHandler = (e) => {
    dispatch(filterActions.setText(e.target.value));
  };
  const catChangeHandler = (e) => {
    dispatch(filterActions.setCategory(e.target.value));
  };
  const levelChangeHandler = (e) => {
    dispatch(filterActions.setLevel(e.target.value));
  };
  const locationChangeHandler = (e) => {
    dispatch(filterActions.setLocation(e.target.value));
  };
  const salaryChangeHandler = (e) => {
    dispatch(filterActions.setSalary(e.target.value));
  };

  const handleTools = (e) => {
    dispatch(filterActions.setTools(e.target.value));
    setTools(e.target.value);
  };
  const apply = (e) => {
    e.preventDefault();
    setSearchTags({
      text: text,
      tools: tool,
      location: location,
    });
    api
      .findTalent(
        `?search=${text}&badges=${projectTypeState}&tools=${tool}&location=${location}&salary=${salary}`
      )
      .then((res) => {
        dispatch(recruiterActions.setTalents(res.data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const projectType = [
    "NFT",
    "3D Environment",
    "Interaction Design",
    "Simulation",
    "Digital twin",
    "Unreal Experience",
  ];

  const availability = ["All", "Full Time", "Freelance"];

  const handleSelect = (item) => {
    if (projectTypeState === item) {
      setProjectTypeState("");
      return;
    }
    setProjectTypeState(item);
  };

  return (
    <div className={style.filterCont2 + " " + "border-none"}>
      <div className={style.searchCont + " " + "mobile-d-none"}>
        <div className={style.searchText}>Search</div>
        <div className={style.searchIconInput}>
          <div className={style.searchIcon}>
            <img src={search} alt="searchIcon" />
          </div>
          <div className={style.compsearch}>
            <input
              type="text"
              placeholder="Search by job role, company name, skills"
              value={text}
              onChange={searchChangeHandler}
              onKeyDown={(e) => e.key === "Enter" && apply(e)}
              autoComplete="off"
            />
          </div>
        </div>
        <div className={style.filter}>
          <img src={filterIcon} alt="" />
        </div>
      </div>

      <div className={style.orLine + " " + "mobile-d-none"}>
        <div className={style.leftLine}></div>
        <div style={{ color: "black", fontWeight: "500" }}>or</div>
        <div className={style.rightLine}></div>
      </div>
      <div className={style.filterTxt} style={{ display: "none" }}>
        Filter
      </div>
      <div className={style.prefence} style={{ display: "none" }}>
        <input type="checkbox" autoComplete="off" />
        <label htmlFor="" className={style.preferenceTxt}>
          As my prefence
        </label>
      </div>
      <form className={style.formCont}>
        <div className={style.labels}>
          <label htmlFor="">Location</label>
        </div>
        <div className={style.labelinput}>
          <input
            type="text"
            placeholder="E.g Thane mumbai"
            value={location}
            onChange={locationChangeHandler}
            autoComplete="off"
          />
        </div>
        <div
          className={style.labels}
          style={{
            paddingTop: "1rem",
          }}
        >
          <label htmlFor="">Badge</label>
        </div>
        <Wrap mx={2} mb={5}>
          {projectType.map((item, index) => (
            <Box onClick={() => handleSelect(index + 1)}>
              <Chip
                name={item}
                bg={projectTypeState === index + 1 ? "#E2DDFE" : ""}
              />
            </Box>
          ))}
        </Wrap>
        {/* <div className={style.labels}>
          <label htmlFor="">Availability</label>
        </div> 
         <Wrap mx={2}>
          {availability.map((item) => (
            <Box onClick={() => setTools(item)}>
              <Chip name={item} bg={tools === item ? "#E2DDFE" : ""} />
            </Box>
          ))}
        </Wrap> */}
        <div className={style.labels}>
          <label htmlFor="">Tools Used</label>
        </div>
        <div className={style.labelinput}>
          <input
            type="text"
            placeholder="E.g Unreal, Blender"
            value={tool}
            onChange={handleTools}
            autoComplete="off"
          />
        </div>

        <div className={style.applyFilterBtn}>
          <button
            type="submit"
            onClick={apply}
            onKeyDown={(e) => {
              e.preventDefault();
              if (e.key === "Enter") {
                apply();
              }
            }}
          >
            Apply filter
          </button>
        </div>
      </form>
    </div>
  );
};

export default PortFolioFilter;
